export default __webpack_public_path__ + "static/thumb-shoes-790af118b6786671e462b10b77b7e40d.png";